import * as actions from "store/actions/user/create";
import IUser from "Types/User";

export interface UserCreateState extends IUser {
	loading: boolean;
	errors: any;

}

const initialState: UserCreateState = {
	loading: false,
	name: "",
	lastname: "",
	email: "",
	role: "",
	roles: [],
	phoneNumber: "",
	birthDate: undefined,
	cpf: "",
	status: 0,
	userStatus: 1,
	bankStatus: 0,
	avatar: "",
	address: {
		street: "",
		number: "",
		complement: "",
		neighborhood: "",
		city: "Curitiba",
		state: "PR",
		country: "BR",
		zipCode: ""
	},
	errors: {}
};

const reducer = function (state = initialState, { type, payload }: any) {
	switch (type) {
		case actions.CREATE_USER: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.CREATE_USER_SUCCESS: {
			return {
				...initialState
			};
		}
		case actions.CREATE_USER_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
